<template>
  <VDropdown
    popper-class="v-popper--comments-settings-dropdown"
    :distance="5"
    placement="bottom"
  >
    <button type="button" class="settings-button">
      <svg-icon
        class="settings_icon"
        :width="'12'"
        :height="'12'"
        icon="app-icons/comment-settings"
      />
    </button>
    <template #popper>
      <div class="button" @click="onClickShowResolved">
        <span>Show resolved comments</span>
        <svg-icon
          v-if="getShowResolved"
          :fill="'#db841e'"
          :width="'16'"
          :height="'16'"
          icon="app-icons/check"
        />
      </div>
      <div class="button" @click="onClickAllowNotifications">
        <span>Receive email notifications</span>
        <svg-icon
          v-if="getAllowNotifications"
          :fill="'#db841e'"
          :width="'16'"
          :height="'16'"
          icon="app-icons/check"
        />
      </div>
    </template>
  </VDropdown>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SvgIcon from '../SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },

  computed: {
    ...mapGetters('project/config/comments', [
      'getShowResolved',
      'getAllowNotifications',
    ]),
    ...mapGetters('project/data/comments', ['getAllThreads']),
  },

  methods: {
    ...mapActions('project/config/comments', [
      'setOpen',
      'setShowResolved',
      'setAllowNotifications',
      'deselectMany',
    ]),

    /**
     * Event handler for clicking on show resolved menu button.
     * Toggle resolved state
     */
    onClickShowResolved() {
      const value = !this.getShowResolved;
      // In case we hide resolved comments, deselect them also
      if (!value) {
        const ids = this.getAllThreads(false)
          .filter(comment => comment.resolved)
          .map(comment => comment.id);

        this.deselectMany({ ids, apply: false });
      }
      this.setShowResolved({ value, apply: true });
    },

    /**
     * Event handler for clicking on allow notifications menu button.
     * Toggle allow notifications state
     */
    onClickAllowNotifications() {
      const value = !this.getAllowNotifications;
      this.setAllowNotifications({ value, apply: true });
    },
  },
};
</script>

<style scoped lang="scss">
.settings-button {
  -webkit-appearance: none;
  appearance: none;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  display: flex !important;
  height: 28px;
  justify-content: center;
  width: 28px;
  background: transparent;
  border: none;

  &:hover,
  &[data-popper-shown] {
    background: #242929;
  }
}
</style>
<style lang="scss">
.v-popper--theme-dropdown.v-popper--comments-settings-dropdown {
  .v-popper__inner {
    background: #2c3233;
    border-radius: 3px;
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.5);
    color: #bcbcbc;
    overflow: hidden;
    padding: 0;
    border: none;
  }

  .button {
    -webkit-appearance: none;
    appearance: none;
    align-items: center;
    color: inherit;
    cursor: pointer;
    display: flex;
    font-size: 13px;
    min-width: 240px;
    padding: 12px 20px;
    text-align: left;
    text-decoration: none;

    &:hover {
      background: #3a4143;
    }

    span {
      flex: 1;
      margin: 0 20px 0 0;
    }
  }

  .v-popper__arrow-container {
    .v-popper__arrow-outer {
      border-color: #2c3233;
    }
    .v-popper__arrow-inner {
      border-color: #2c3233;
    }
  }
}
</style>
